// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollToTop-module--button--3FaU-","none":"ScrollToTop-module--none--2Nw_P"};